/**
 * WebAction vynuluje cilovy input
 */

export default (props, e) => {
	e.stopPropagation();
	const {
		actionTarget,
		separator = ';',
	} = props;
	// const { target } = e;

	if ( actionTarget ) {
		const targetSet = actionTarget.split(separator);
		targetSet.forEach( (element) => {
			[ ...document.querySelectorAll(element) ].forEach( (elm) => {
				if ( elm instanceof HTMLInputElement && (elm.type === 'checkbox' || elm.type === 'radio') ) {
					elm.checked = false;
					elm.value = 0;
				} else {
					elm.value = '';
				}
				elm.dispatchEvent( new Event('change') );
			});
		});
	}
};



// WEBPACK FOOTER //
// ./fe/web-auto/src/js/webActions/clearInput.js